



































































































































import storeHelper from "@/store/store-helper";
import { DocumentAnchor, DocumentTypePrimitive, UserMini } from "@infoland/iprova-api";
import { CommentState, CommentType, DocumentCommentListMode } from "@/enums";
import { Comment } from "@/documentComments";
import ZenyaDialog from "@/components/dialogs/ZenyaDialog.vue";
import CommentDialog from "@/components/dialogs/CommentDialog.vue";
import Vue from "vue";
import DocumentCommentCard from "./DocumentCommentCard.vue";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import { filterCommentsByDocumentCommentListMode } from "@/documentComments";
export default Vue.extend({
    name: "CommentsContainer",
    props: {
        commentSubjectSelections: { type: Array as () => DocumentAnchor[] },
        isDocumentCheck: Boolean,
        isReviewDocument: Boolean,
        userIsDocumentWriter: Boolean,
        documentAdministrators: { type: Array as () => UserMini[] },
        documentProperties: Object as () => DocumentVersionInfo,
        documentContentLoaded: Boolean,
        commenterTypeForAddingComment: String as () => CommentType
    },
    components: { DocumentCommentCard, ZenyaDialog, CommentDialog },
    data: () => ({ commentDialogVisible: false }),
    computed: {
        isStructuredDocument(): boolean {
            return this.documentProperties.type === DocumentTypePrimitive.structured_document;
        },
        isInteractiveDocument(): boolean {
            return this.documentProperties.type === DocumentTypePrimitive.interactive;
        },
        isFreeWebDocument(): boolean {
            return this.documentProperties.type === DocumentTypePrimitive.free_web;
        },
        documentComments(): Comment[] {
            return filterCommentsByDocumentCommentListMode(
                storeHelper.documentStore.documentComments,
                this.documentProperties.version,
                this.documentProperties.state,
                this.isReviewDocument
                    ? DocumentCommentListMode.review
                    : this.isDocumentCheck
                    ? DocumentCommentListMode.management
                    : DocumentCommentListMode.read,
                this.$user
            );
        },
        commentAnchors(): DocumentAnchor[] {
            let commentAnchors: DocumentAnchor[] = [];
            this.documentComments.forEach(comment => {
                if (comment.anchor_id) {
                    if (!commentAnchors.find(f => f.id == comment.anchor_id)) {
                        const commentAnchor: DocumentAnchor = { id: comment.anchor_id, text: comment.anchor_text, type: comment.anchor_type };
                        commentAnchors.push(commentAnchor);
                    }
                }
            });
            return commentAnchors;
        },
        hasAtLeastOneGeneralComment(): boolean {
            return this.documentComments.some(c => (c.anchor_id && c.anchor_id.length === 0) || !c.anchor_id);
        },
        userIsWriter(): boolean {
            return this.currentUserIsDocumentAdministrator || this.userIsDocumentWriter;
        },
        canEditDocument(): boolean {
            return storeHelper.documentStore.documentInfo.can_be_edited;
        },
        currentUserIsDocumentAdministrator(): boolean {
            const currentUserAdmin = this.documentAdministrators.find(da => da.user_id === this.$user.user_id);
            if (currentUserAdmin) {
                return true;
            }
            return false;
        }
    },
    destroyed() {
        storeHelper.documentStore.clearDocumentComments();
    },
    watch: {
        documentComments: {
            handler(newValue, oldValue) {
                if (newValue && oldValue && newValue.length > oldValue.length && oldValue.length > 1) {
                    this.$nextTick(() => {
                        this.$nextTick(() => {
                            let lastCommentId = newValue[newValue.length - 1].comment_id;
                            let comment = document.getElementById(`comment_${lastCommentId}`);
                            let commentsContainer = this.$refs.commentsContainer as Element;
                            commentsContainer.scrollTop = comment.offsetTop - 60;
                        });
                    });
                }
            },
            immediate: false
        },
        commentDialogVisible: {
            handler(newValue) {
                storeHelper.siteStore.setIsDialogDisplayed(newValue);
            }
        }
    },
    methods: {
        canDeleteComment(comment: Comment) {
            if (comment.state === CommentState.New || !comment.state) {
                var commenterIsDocAdmin = this.documentAdministrators.find(da => da.user_id === comment.creator_id);
                if (comment.creator_id === this.$user.user_id || (this.currentUserIsDocumentAdministrator && commenterIsDocAdmin)) {
                    return true;
                }
            }
        },
        commentStateEditable(commentType: CommentType): boolean {
            return (
                this.isDocumentCheck &&
                this.currentUserIsDocumentAdministrator &&
                (commentType === CommentType.Reader || commentType === CommentType.Reviewer)
            );
        },
        rejectCommentDialog(newValue: boolean): void {
            this.$emit("is-dialog-displayed", newValue);
        }
    }
});
